module.exports = __webpack_public_path__ + "static/media/banna.ad398109.jpeg";